import ChPlayComponent from "../components/staticPage/chPlay.component";
import FeatureComponent from "../components/staticPage/feature.component";
import HeroComponent from "../components/staticPage/hero.component";
import IntroductionComponent from "../components/staticPage/introduction.component";
import PaymentRuleComponent from "../components/staticPage/paymentRule.component";
import PointComponent from "../components/staticPage/point.component";
import PrivacyPolicyComponent from "../components/staticPage/privacyPolicy.component";
import TermComponent from "../components/staticPage/term.component";
import TransactionRuleComponent from "../components/staticPage/transactionRule.component";
import "../styles/HomeLayout.css";

function HomeLayout({ children }: any) {
  return (
    <div className="home-wrapper">
      {children}
      <div id="top" className="top-wrapper"></div>

      <div className="main-content">
        <section id="section1">
          <HeroComponent />
        </section>
        <section id="section2">
          <IntroductionComponent />
        </section>
        <section id="section3">
          <FeatureComponent />
        </section>
        <section id="section4">
          <TermComponent />
        </section>
        <section id="section5">
          <PrivacyPolicyComponent />
        </section>
        <section id="section7">
          <TransactionRuleComponent />
        </section>
        <section id="section8">
          <PaymentRuleComponent />
        </section>
        <section id="section9">
          <PointComponent />
        </section>
        <section id="section10">
          <ChPlayComponent />
        </section>
        <div className="footer">
          <p>© monaka-soft.com</p>
        </div>
      </div>
    </div>
  );
}

export default HomeLayout;
